import { create } from "zustand";

const MAX_TOASTS = 3;

let nextId = 1;

export const useToastStore = create((set) => ({
  toasts: [],
  addToast: (type, message) =>
    set((state) => {
      const toasts = [...state.toasts, { id: nextId++, type, message }];
      return { toasts: toasts.slice(-MAX_TOASTS) };
    }),
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}));
